import { MatchForecast } from '../../interfaces/tip/MatchForecast';
import { Tip, TipType } from '../../interfaces/tip/Tip';
import { FormattedOdds, PriceType } from '../../interfaces/utils';
import { MatchForecastType } from '../../MatchSwitcher/MatchSwitcher';
import { formatRate } from './functionsDTO';

export class TipPublishData {
  public type: TipType;
  public channel_id?: string;

  /* Matches */
  public match_forecasts: MatchForecast[];
  public started_at: string;
  public rate: number;
  public stake: number;

  /* Bookies */
  public bookie_id?: string;
  public bookie?: string;

  /* Misc */
  public analysis: string | undefined;
  public media_files_ids: string[] | null;
  public betslip_image_id: string;

  /* Price Data */
  public safe_price_amount?: number | null;
  public unlocked_at?: string | null;
  public formatted_odds: FormattedOdds | undefined;
  public price_type: PriceType | null;
  public pricing_tier_code?: string | null;
  public web_discount_percentage: number;

  constructor(
    {
      type,
      channel,
      matchForecasts,
      analysis,
      stake,
      bookie,
      priceType,
      pricingTierCode,
      accumulatedOdds,
      discountPercentage,
    }: Tip,
    media_files_ids: string[],
    betslip_image_id: string,
  ) {
    this.rate = formatRate(accumulatedOdds);
    this.formatted_odds = accumulatedOdds;
    this.started_at = this.getTotalStartedAt(matchForecasts);
    this.bookie_id = bookie.id;
    this.match_forecasts = this.buildMatchForecasts(matchForecasts);
    this.type = type;
    if (channel.id.length) {
      this.channel_id = channel.id;
    }
    this.bookie = bookie.code;
    this.stake = stake;
    this.analysis = analysis;
    this.media_files_ids = media_files_ids;
    this.betslip_image_id = betslip_image_id;
    this.price_type = priceType;
    if (pricingTierCode.length) {
      this.pricing_tier_code = pricingTierCode;
    }
    this.web_discount_percentage = discountPercentage;

    // removeEmptyValues will remove all null fields from the DTO.
    this.removeEmptyValues();
  }

  private removeEmptyValues(object?: any): void {
    if (object) {
      for (let key in object) {
        if (object[key] === null) {
          delete object[key];
        } else if (
          object[key] instanceof Object &&
          !(object[key] instanceof Array)
        ) {
          this.removeEmptyValues(object[key]);
          return;
        }
      }
    } else {
      for (let key in this) {
        if (this[key] === null) {
          delete this[key];
        } else if (
          this[key] instanceof Object &&
          !(this[key] instanceof Array)
        ) {
          this.removeEmptyValues(this[key] as Object);
          return;
        }
      }
    }
  }

  private getTotalStartedAt(matches: MatchForecast[]): string {
    let newDate = new Date('01/01/9999');
    matches.forEach((match) => {
      const start_date = new Date(match.start_date);
      if (start_date < newDate) {
        newDate = start_date;
      }
    });
    return newDate.toISOString();
  }

  private buildMatchForecasts(matches: any): MatchForecast[] {
    const matchForecasts: MatchForecast[] = matches.map(
      (match: MatchForecast) => {
        const { type, formatted_odds, tip, market } = match;

        if (type === MatchForecastType.CUSTOM) {
          const {
            sport,
            competition_name,
            home_player,
            away_player,
            start_date,
          } = match;

          return {
            market: market.code,
            market_code: market.code,
            pick: tip,
            formatted_odds,
            rate: formatRate(formatted_odds),
            match: {
              sport: sport.code,
              competition_name,
              home_player,
              away_player,
              start_date,
            },
          };
        } else {
          return {
            market: market.code,
            market_code: market.code,
            pick: tip,
            formatted_odds,
            rate: formatRate(formatted_odds),
            match_id: match.match_id,
          };
        }
      },
    );
    return matchForecasts;
  }
}
export function toDTO(
  tip: Tip,
  media_files_ids: string[],
  betslip_image_id: string,
): string {
  return JSON.stringify(
    new TipPublishData(tip, media_files_ids, betslip_image_id),
  );
}

export function toObject(
  tip: Tip,
  media_files_ids: string[],
  betslip_image_id: string,
): TipPublishData {
  return new TipPublishData(tip, media_files_ids, betslip_image_id);
}
